import React, { useEffect, useRef } from 'react';
type ContactModalProps = {
  isOpen: boolean;
  onClose: () => void;
};
export function ContactModal({
  isOpen,
  onClose
}: ContactModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!isOpen) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeButtonRef.current?.focus();
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
        return;
      }
      if (event.key !== 'Tab' || !modalRef.current) return;
      const focusable = modalRef.current.querySelectorAll<HTMLElement>('button:not([disabled]), [href]');
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!first || !last) return;
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div ref={modalRef} className="contact-modal" role="dialog" aria-modal="true" aria-labelledby="contact-modal-title" aria-describedby="contact-modal-subtitle" data-id="element-86">
      <button ref={closeButtonRef} type="button" className="contact-modal__close" onClick={onClose} aria-label="Cerrar contacto" data-id="element-87">
        ×
      </button>

      <div className="contact-modal__content" data-id="element-88">
        <p className="contact-modal__eyebrow" data-id="element-89">SAVIA</p>
        <h2 id="contact-modal-title" data-id="element-90">Escríbenos</h2>
        <p id="contact-modal-subtitle" className="contact-modal__subtitle" data-id="element-91">
          Respondemos en 24 horas hábiles · Bogotá, Colombia
        </p>

        <div className="contact-modal__cards" data-id="element-92">
          <a className="contact-card" href="https://instagram.com/savia.ritualco" target="_blank" rel="noopener noreferrer" data-id="element-93">
            <span className="contact-card__label" data-id="element-94">Instagram</span>
            <span className="contact-card__detail" data-id="element-95">@savia.ritualco</span>
            <span className="contact-card__arrow" aria-hidden="true" data-id="element-96">
              →
            </span>
          </a>

          <a className="contact-card" href="https://wa.me/57310XXXXXXX" target="_blank" rel="noopener noreferrer" data-id="element-97">
            <span className="contact-card__label" data-id="element-98">WhatsApp</span>
            <span className="contact-card__detail" data-id="element-99">+57 310 XXX XXXX</span>
            <span className="contact-card__arrow" aria-hidden="true" data-id="element-100">
              →
            </span>
          </a>
        </div>
      </div>
    </div>;
}